<template>
    <div v-if="isCmiste == false">
        <ubi-panel>
            <ubi-form-group :title="$t('posts.landTitle')">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.longueur_terrain"
                                      prop="longueur_terrain"
                                      :rules="[
                                            { type: 'number', message: this.$t('validator.mustBeNumericValue')}
                                      ]">
                            <el-input v-model.number="post.longueur_terrain" type="longueur_terrain">
                                <div slot="append">m</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.largeur_terrain"
                                      prop="largeur_terrain"
                                      :rules="[
                                            { type: 'number', message: this.$t('validator.mustBeNumericValue')}
                                      ]">
                            <el-input v-model.number="post.largeur_terrain" type="largeur_terrain">
                                <div slot="append">m</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item :label="$labels.avec_pente">
                        <el-radio v-model="post.avec_pente" label="oui">{{ $t("general.yes") }}</el-radio>
                        <el-radio v-model="post.avec_pente" label="non">{{ $t("general.no") }}</el-radio>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item :label="$labels.viabilise">
                        <el-radio v-model="post.viabilise" label="oui">{{ $t("general.yes") }}</el-radio>
                        <el-radio v-model="post.viabilise" label="non">{{ $t("general.no") }}</el-radio>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.lotissement">
                            <el-radio v-model="post.lotissement" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.lotissement" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.constructible">
                            <el-radio v-model="post.constructible" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.constructible" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.exposition">
                            <el-select
                                    v-model="post.exposition"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="expositionChoice in this.$parent.getChoices('exposition')"
                                        :key="expositionChoice"
                                        :label="expositionChoice"
                                        :value="expositionChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.belle_vue">
                            <el-radio v-model="post.belle_vue" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.belle_vue" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.avec_vis_a_vis">
                            <el-radio v-model="post.avec_vis_a_vis" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.avec_vis_a_vis" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.certificat_urbanisme">
                            <el-radio v-model="post.certificat_urbanisme" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.certificat_urbanisme" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.environmentTitle')">
                            <el-select
                                    v-model="post.environnement"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="environnementChoice in this.$parent.getChoices('environnement')"
                                        :key="environnementChoice"
                                        :label="environnementChoice"
                                        :value="environnementChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.shon"
                                      prop="shon"
                                      :rules="[
                                            { type: 'number', message: this.$t('validator.mustBeNumericValue')}
                                      ]">
                            <el-input v-model.number="post.shon" type="shon">
                                <div slot="append">m²</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.cos"
                                      prop="cos">
                            <el-input type="number" v-model="post.cos" step="0.01">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>
    </div>

    <div v-else>
        <ubi-panel>
            <ubi-form-group :title="$t('posts.landTitle')">
                <el-row ::gutter="24">
                    <el-col :span="24">
                        <el-form-item :label="$labels.longueur_terrain"
                                      prop="longueur_terrain"
                                      :rules="[
                                            { type: 'number', message: this.$t('validator.mustBeNumericValue')}
                                      ]">
                            <el-input v-model.number="post.longueur_terrain" type="longueur_terrain">
                                <template slot="append">M</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.largeur_terrain"
                                      prop="largeur_terrain"
                                      :rules="[
                                            { type: 'number', message: this.$t('validator.mustBeNumericValue')}
                                      ]">
                            <el-input v-model.number="post.largeur_terrain" type="largeur_terrain">
                                <template slot="append">M</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.land')">
                            <el-checkbox v-model="post.avec_pente" true-label="oui" false-label="non">{{ $t("posts.edit.checkboxLandWithSlope") }}</el-checkbox>
                            <el-checkbox v-model="post.viabilise" true-label="oui" false-label="non">{{ $t("posts.edit.checkboxLandServiced") }}</el-checkbox>
                            <el-checkbox v-model="post.lotissement" true-label="oui" false-label="non">{{ $t("posts.edit.checkboxLandAllotment") }}</el-checkbox>
                            <el-checkbox v-model="post.constructible" true-label="oui" false-label="non">{{$t("posts.edit.checkboxLandBuildable") }}</el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$labels.exposition">
                            <el-select
                                    v-model="post.exposition"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="expositionChoice in this.$parent.getChoices('exposition')"
                                        :key="expositionChoice"
                                        :label="expositionChoice"
                                        :value="expositionChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{ $t("posts.edit.location") }}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.environnement != '' && post.environnement != undefined && post.environnement != null"
                                           @click="post.environnement = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.environnement">
                                <el-radio
                                        v-for="environnementChoice in this.$parent.getChoices('environnement')"
                                        :label="environnementChoice"
                                        :value="environnementChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item :label="$t('posts.edit.locationProximityAndSituation')">
                                <el-checkbox
                                        v-model="post.proche_aeroport"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxAirport") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_sortie_autoroute"
                                        true-label="oui"
                                        false-label="non"
                                >Sortie autoroute
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_gare"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxGare") }}
                                </el-checkbox>
                                <el-checkbox v-model="post.proche_bus" true-label="oui" false-label="non">{{ $t("posts.edit.checkboxBus") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_tram"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxTramway") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_parking"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxParking") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_commerces"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxShops") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_centre_commercial"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxMall") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_centre_ville"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxDowntown") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_creche"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxNursery") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_ecole_primaire"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxPrimarySchool") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_college"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxCollege") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_lycee"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxHighSchool") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_universite"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxUniversity") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.espaces_verts"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxGreenSpaces") }}
                                </el-checkbox>
                                <el-checkbox
                                        v-model="post.proche_metro"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $t("posts.edit.checkboxSubway") }}
                                </el-checkbox>
                                <el-checkbox v-model="post.belle_vue" true-label="oui" false-label="non">{{$labels.belle_vue}}</el-checkbox>
                                <el-checkbox
                                        v-model="post.vue_sur_mer"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $labels.vue_sur_mer }}</el-checkbox>
                                <el-checkbox v-model="post.est_calme"
                                             true-label="oui"
                                             false-label="non"
                                >{{ $labels.est_calme }}</el-checkbox>
                                <el-checkbox
                                        v-model="post.avec_vis_a_vis"
                                        true-label="oui"
                                        false-label="non"
                                >{{ $labels.avec_vis_a_vis }}</el-checkbox>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item :label="$labels.shon"
                                          prop="shon"
                                          :rules="[
                                                { type: 'number', message: this.$t('validator.mustBeNumericValue')}
                                          ]">
                                <el-input v-model.number="post.shon" type="shon">
                                    <template slot="append">m²</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="$labels.cos"
                                          prop="cos">
                                <el-input type="number" v-model="post.cos" step="0.01">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
            </ubi-form-group>
        </ubi-panel>
        <ubi-panel  v-if="isARLOGIS">
            <ubi-form-group :title="$t('posts.propertyPartnerTitle')">
                <el-row ::gutter="24">
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.propertyPartnerCompany')">
                            <el-input v-model="post.societe_partenaire_foncier">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.propertyPartnerLastname')">
                            <el-input v-model="post.nom_partenaire_foncier">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.propertyPartnerFirstname')">
                            <el-input v-model="post.prenom_partenaire_foncier">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.propertyPartnerPhone')">
                            <el-input v-model.number="post.telephone_partenaire_foncier">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>
    </div>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'

export default {
  name: 'PostEditImmoObject1300',
  props: ['post', 'ddList'],
  data () {
    return {
    }
  },
  computed: {
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    userJob () {
      return this.sitimmoUser.metier
    },
    isARLOGIS () {
      return this.sitimmoUser.reseau === 'ARLOGIS'
    },
    isCmiste () {
      return this.userJob === 'CMI'
    }
  },
  methods: {},
  async beforeMount () {
    let codes = [
      'environnement',
      'mandat_statut',
      'modalites_recuperation_charges_locatives',
      'exposition',
      'devise_iso_4217',
      'honoraires_payeurs',
      'type_voie'
    ]
    codes = codes.map(function (x) {
      return x.toUpperCase()
    })
    const definitionDonneeListeeByCode = await getDefinitionDonneeListeeByCode({ codes: codes })
    if (definitionDonneeListeeByCode.type == 'error') {
      this.$message({ message: this.$t('error.found'), type: 'error' })
      this.loading = false
      return false
    }

    this.$emit('update:ddList', await getDefinitionDonneeListeeByCode({ codes: codes }))
  }
}
</script>
